// Mock data for The Wallness app

export const navigationItems = [
  { id: 'for-you', label_en: 'For you', label_es: 'Para ti', path: '/for-you' },
  { id: 'for-professionals', label_en: 'For Professionals', label_es: 'Para Profesionales', path: '/professionals' },
  { id: 'for-teams', label_en: 'For Teams', label_es: 'Para Equipos', path: '/teams' },
  { id: 'why-wallness', label_en: 'Why The Wallness', label_es: '¿Por qué The Wallness?', path: '/why' }
];

export const heroContent = {
  title_en: 'Build Your Wall',
  title_es: 'Construye Tu Muro',
  subtitle_en: 'Brick by brick, become your best version',
  subtitle_es: 'Ladrillo por ladrillo, conviértete en tu mejor versión',
  description_en: 'The complete wellness platform founded by Christiane Endler. Fitness, Nutrition, Wellbeing, and Football - all in one place.',
  description_es: 'La plataforma de bienestar integral fundada por Christiane Endler. Fitness, Nutrición, Bienestar y Fútbol - todo en un solo lugar.',
  cta_primary_en: 'Start Your Journey',
  cta_primary_es: 'Comienza Tu Camino',
  cta_secondary_en: 'Download App',
  cta_secondary_es: 'Descargar App'
};

export const featureCards = [
  {
    id: 'mental-health',
    icon: 'Brain',
    title_en: 'Mental Strength',
    title_es: 'Fortaleza Mental',
    description_en: 'Build mental resilience with guided meditation and mindfulness techniques',
    description_es: 'Desarrolla resiliencia mental con meditación guiada y técnicas de atención plena',
    image: 'https://images.pexels.com/photos/3759657/pexels-photo-3759657.jpeg'
  },
  {
    id: 'sleep',
    icon: 'Moon',
    title_en: 'Sleep Better',
    title_es: 'Duerme Mejor',
    description_en: 'Optimize your sleep patterns for improved recovery and well-being',
    description_es: 'Optimiza tus patrones de sueño para mejorar la recuperación y el bienestar',
    image: 'https://images.pexels.com/photos/14466078/pexels-photo-14466078.jpeg'
  },
  {
    id: 'fitness',
    icon: 'Dumbbell',
    title_en: 'Train Like a Champion',
    title_es: 'Entrena Como una Campeona',
    description_en: 'Personalized fitness programs designed for women athletes',
    description_es: 'Programas de fitness personalizados diseñados para mujeres atletas',
    image: 'https://customer-assets.emergentagent.com/job_endler-stats/artifacts/r0t4e1v4_IMG_0017.webp'
  },
  {
    id: 'nutrition',
    icon: 'Apple',
    title_en: 'Fuel Your Body',
    title_es: 'Alimenta Tu Cuerpo',
    description_en: 'Nutrition plans tailored to your goals and lifestyle',
    description_es: 'Planes de nutrición adaptados a tus objetivos y estilo de vida',
    image: 'https://images.unsplash.com/photo-1552196527-bffef41ef674'
  },
  {
    id: 'stress',
    icon: 'Heart',
    title_en: 'Lower Your Stress',
    title_es: 'Reduce Tu Estrés',
    description_en: 'Mindfulness and stress management techniques for better mental health',
    description_es: 'Técnicas de atención plena y manejo del estrés para mejor salud mental',
    image: 'https://customer-assets.emergentagent.com/job_endler-stats/artifacts/12r7l7ur_IMG_0011.jpeg'
  },
  {
    id: 'community',
    icon: 'Users',
    title_en: 'Join the Community',
    title_es: 'Únete a la Comunidad',
    description_en: 'Connect with women building their walls worldwide',
    description_es: 'Conecta con mujeres construyendo sus muros en todo el mundo',
    image: 'https://images.unsplash.com/photo-1687180948607-9ba1dd045e10'
  }
];

export const appFeatures = [
  {
    id: 'wearable',
    icon: 'Watch',
    title_en: 'Sync with Wearables',
    title_es: 'Sincroniza con Wearables',
    description_en: 'Your wearable gives you the data, The Wallness gives you the plan',
    description_es: 'Tu wearable te da los datos, The Wallness te da el plan'
  },
  {
    id: 'personalized',
    icon: 'Target',
    title_en: 'Personalized Plans',
    title_es: 'Planes Personalizados',
    description_en: 'AI-powered programs adapted to your goals and progress',
    description_es: 'Programas potenciados por IA adaptados a tus objetivos y progreso'
  },
  {
    id: 'football',
    icon: 'Trophy',
    title_en: 'Football Training',
    title_es: 'Entrenamiento de Fútbol',
    description_en: 'Specialized goalkeeper and football training programs',
    description_es: 'Programas especializados de entrenamiento de portería y fútbol'
  }
];

export const christianeAchievements = [
  {
    id: 'fifa-best',
    year: '2021',
    title_en: 'FIFA Best Goalkeeper',
    title_es: 'Mejor Portera FIFA',
    description_en: 'Named FIFA Women\'s Goalkeeper of the Year',
    description_es: 'Nombrada Portera del Año FIFA Femenino'
  },
  {
    id: 'champions-league',
    year: '2022',
    title_en: 'Champions League Winner',
    title_es: 'Ganadora Champions League',
    description_en: 'Won UEFA Women\'s Champions League with Lyon',
    description_es: 'Ganó la UEFA Champions League Femenina con Lyon'
  },
  {
    id: 'fifpro',
    year: '2020-2022',
    title_en: 'FIFPRO World 11',
    title_es: 'FIFPRO World 11',
    description_en: 'Selected three times to FIFPRO Women\'s World 11',
    description_es: 'Seleccionada tres veces en el FIFPRO World 11 Femenino'
  },
  {
    id: 'league-champion',
    year: 'Multiple',
    title_en: 'League Champion',
    title_es: 'Campeona de Liga',
    description_en: 'Multiple league titles in France and South America',
    description_es: 'Múltiples títulos de liga en Francia y Sudamérica'
  }
];

export const founderSection = {
  title_en: 'FOUNDED BY',
  title_es: 'FUNDADO POR',
  name: 'CHRISTIANE ENDLER',
  subtitle_en: 'World-Class Goalkeeper | Wellness Advocate',
  subtitle_es: 'Portera de Clase Mundial | Defensora del Bienestar',
  quote_en: '"Building my wall taught me that consistency beats perfection. Every brick matters, every day counts. I created The Wallness to help women build their own walls - brick by brick, goal by goal."',
  quote_es: '"Construir mi muro me enseñó que la consistencia supera la perfección. Cada ladrillo importa, cada día cuenta. Creé The Wallness para ayudar a las mujeres a construir sus propios muros - ladrillo por ladrillo, objetivo por objetivo."',
  image: 'https://customer-assets.emergentagent.com/job_7ae3c590-a900-495e-96a4-83dcf051e5e9/artifacts/aoh18g1k_250123344.webp'
};

export const formulaSection = {
  title_en: 'The Wallness Formula',
  title_es: 'La Fórmula Wallness',
  formula: 'Fitness × Nutrition × Wellbeing × Football = Longevity',
  description_en: '"You don\'t need to be perfect, you just need to be consistent. When you take care of your body and mind every day, life becomes easier."',
  description_es: '"No necesitas ser perfecta, solo necesitas ser consistente. Cuando cuidas tu cuerpo y mente cada día, la vida se vuelve más fácil."',
  quote_author: 'Christiane Endler'
};

export const statsSection = [
  {
    number: '100K+',
    label_en: 'Active Users',
    label_es: 'Usuarios Activos'
  },
  {
    number: '50+',
    label_en: 'Expert Coaches',
    label_es: 'Entrenadoras Expertas'
  },
  {
    number: '1000+',
    label_en: 'Training Programs',
    label_es: 'Programas de Entrenamiento'
  },
  {
    number: '45',
    label_en: 'Countries',
    label_es: 'Países'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'María González',
    role_en: 'Amateur Footballer',
    role_es: 'Futbolista Amateur',
    image: 'https://images.pexels.com/photos/3319180/pexels-photo-3319180.jpeg',
    quote_en: 'The Wallness helped me build not just physical strength, but mental resilience. Every brick counts!',
    quote_es: 'The Wallness me ayudó a construir no solo fuerza física, sino resiliencia mental. ¡Cada ladrillo cuenta!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ana Silva',
    role_en: 'Fitness Enthusiast',
    role_es: 'Entusiasta del Fitness',
    image: 'https://images.pexels.com/photos/9501964/pexels-photo-9501964.jpeg',
    quote_en: 'Finally, a wellness platform that understands women athletes. The football training is exceptional!',
    quote_es: 'Finalmente, una plataforma de bienestar que entiende a las mujeres atletas. ¡El entrenamiento de fútbol es excepcional!',
    rating: 5
  },
  {
    id: 3,
    name: 'Sofia Martínez',
    role_en: 'Professional Goalkeeper',
    role_es: 'Portera Profesional',
    image: 'https://images.pexels.com/photos/13461456/pexels-photo-13461456.jpeg',
    quote_en: 'Christiane\'s approach to holistic wellness transformed my game and my life.',
    quote_es: 'El enfoque holístico de Christiane transformó mi juego y mi vida.',
    rating: 5
  }
];

export const newsletterContent = {
  title_en: 'Build Your Wall Today!',
  title_es: '¡Construye Tu Muro Hoy!',
  subtitle_en: 'Get all the updates and exclusive content',
  subtitle_es: 'Recibe todas las actualizaciones y contenido exclusivo',
  placeholder_en: 'Type your email',
  placeholder_es: 'Escribe tu email',
  button_en: 'Join Now!',
  button_es: '¡Únete Ahora!'
};

export const bookSection = {
  badge_en: 'The Book',
  badge_es: 'El Libro',
  title_en: 'The Endler Wall',
  title_es: 'El Muro Endler',
  subtitle_en: 'How to build an unbreakable defense and conquer the world',
  subtitle_es: 'Cómo construir una defensa inquebrantable y conquistar el mundo',
  description_en: 'The book that inspired The Wallness. A manual of life disguised as a football story. Because Tiane doesn\'t just stop penalties. She builds. She builds confidence when everything collapses. She builds standards when no one demands them. She builds a future when the present seems insufficient.',
  description_es: 'El libro que inspiró The Wallness. Un manual de vida disfrazado de historia de fútbol. Porque Tiane no solo para penales. Construye. Construye confianza cuando todo se derrumba. Construye estándares cuando nadie los exige. Construye futuro cuando el presente parece insuficiente.',
  quote_en: '"The strongest wall is not the one that never receives blows, but the one that receives them all... and remains standing."',
  quote_es: '"El muro más fuerte no es el que nunca recibe golpes, sino el que los recibe todos… y sigue en pie."',
  chapters: [
    { number: 1, title_en: 'The First Brick', title_es: 'El primer ladrillo', subtitle_en: 'From striker to guardian', subtitle_es: 'De delantera a guardiana' },
    { number: 2, title_en: 'Height is Not Just Physical', title_es: 'Altura no es solo física', subtitle_en: 'The foundation of the wall', subtitle_es: 'La base del muro' },
    { number: 3, title_en: 'The Crack That Almost Brought It Down', title_es: 'La grieta que casi lo derrumba', subtitle_en: 'The injury that made it stronger', subtitle_es: 'La lesión que lo hizo más fuerte' },
    { number: 4, title_en: 'Building on Hostile Ground', title_es: 'Construyendo en terreno hostil', subtitle_en: 'Professionalizing what nobody valued', subtitle_es: 'Profesionalizar lo que nadie valoraba' },
    { number: 5, title_en: 'The Cement of Silence', title_es: 'El cemento del silencio', subtitle_en: 'Leadership without needing to shout', subtitle_es: 'Liderazgo sin necesidad de gritar' },
    { number: 6, title_en: 'The Match That Tested the Entire Wall', title_es: 'El partido que probó todo el muro', subtitle_en: 'The Champions League nobody expected', subtitle_es: 'La Champions que nadie esperaba' },
    { number: 7, title_en: 'Maintaining the Wall When It\'s No Longer Necessary', title_es: 'Mantener el muro cuando ya no hace falta', subtitle_en: 'The true level', subtitle_es: 'El verdadero nivel' },
    { number: 8, title_en: 'The 10 Bricks of the Endler Wall', title_es: 'Los 10 ladrillos del Muro Endler', subtitle_en: 'The manual for you to build yours too', subtitle_es: 'El manual para que tú también lo construyas' }
  ],
  bricks: [
    {
      number: 1,
      title_en: 'Foundations of Humility',
      title_es: 'Cimientos de humildad',
      subtitle_en: 'Never believe you\'ve already arrived',
      subtitle_es: 'Nunca creas que ya llegaste',
      description_en: 'The first brick is always the heaviest. Tiane put it at 15 when Marco Cornez told her she\'d be Chile\'s best goalkeeper. She laughed. But she accepted. Humility is not lowering your ego - it\'s never raising it. "I try to learn day by day, always you can improve more," she says at 34, after two Champions, five French leagues. The wall doesn\'t build in a day. It builds every day. Application: Every time you feel you\'ve "arrived", ask yourself: what brick am I not laying today? Humility is the cement that prevents the wall from falling due to arrogance.',
      description_es: 'El primer ladrillo siempre es el más pesado. Tiane lo puso a los 15 años, cuando Marco Cornez le dijo que sería la mejor arquera de Chile. Ella se rio. Pensó que era una broma. Pero aceptó. Y desde ese día entendió: la humildad no es bajarse el ego. Es nunca subirlo. "Intento aprender día a día, siempre se puede mejorar más", dice ella a los 34 años, después de dos Champions, cinco ligas francesas y ser considerada una de las tres mejores arqueras de la historia. En Colo-Colo, cuando ya era capitana y había ganado la Libertadores 2012, seguía llegando una hora antes al entrenamiento. Las más jóvenes la miraban raro: "Tiane, tú ya eres la mejor". Ella respondía: "Por eso mismo. Si me creo la mejor, dejo de serlo". Aplicación para ti: Cada vez que sientas que "ya llegaste", pregúntate: ¿qué ladrillo estoy dejando de poner hoy? La humildad es el cemento que evita que el muro se caiga por soberbia.',
      icon: 'Layers'
    },
    {
      number: 2,
      title_en: 'Daily Work Bricks',
      title_es: 'Ladrillos diarios de trabajo',
      subtitle_en: 'The discipline nobody sees',
      subtitle_es: 'La disciplina que nadie ve',
      description_en: 'The wall doesn\'t build in a day. It builds every day. Tiane trains at 6:30 AM even when there\'s no match. In Lyon, while the young ones sleep until 8, she\'s already in the gym. In Algarrobo, on vacation, she exercises with Nicolás and family. "Daily work is what separates the good from the great," she says. In 2011, when she arrived at Colo-Colo, the showers were cold and there was no gym. She brought her own weights in a backpack. Nobody saw it. But she did. The daily bricks are the ones nobody applauds. But they\'re the ones that hold up the trophy. Application: Choose one small thing and do it every day. No excuses. That\'s your first invisible brick.',
      description_es: 'El muro no se levanta en un día. Se levanta todos los días. Tiane entrena a las 6:30 de la mañana aunque no haya partido. En Lyon, cuando las jóvenes duermen hasta las 8, ella ya está en el gimnasio. En Algarrobo, en vacaciones, hace deporte con Nicolás y la familia. "El trabajo diario es lo que separa a las buenas de las grandes", dice. En 2011, cuando llegó a Colo-Colo, las duchas eran frías y no había gimnasio. Ella se llevaba sus propias pesas en una mochila. Nadie lo veía. Pero ella sí. Los ladrillos diarios son los que nadie aplaude. Pero son los que sostienen la copa. En la final de la Champions 2022, cuando Barcelona atacaba sin piedad, cada atajada de Tiane no fue casualidad. Fueron años de madrugar, de hacer el trabajo que nadie ve, de repetir el gesto mil veces en soledad. Aplicación para ti: Elige una cosa pequeña y hazla todos los días. Sin excusas. Ese es tu primer ladrillo invisible.',
      icon: 'Calendar'
    },
    {
      number: 3,
      title_en: 'Cement of Silence',
      title_es: 'Cemento del silencio',
      subtitle_en: 'Leadership that doesn\'t need volume',
      subtitle_es: 'Liderazgo que no necesita volumen',
      description_en: 'Tiane was never the loudest in the locker room. At the 2019 World Cup, against Sweden, when the team was nervous, she didn\'t give a speech. She just stood in the center of the circle, looked at each one and said quietly: "We\'re here. I\'ve got you covered". And everyone breathed. In Lyon, the young ones seek her out for advice. She listens more than she talks. She corrects with a hand on the shoulder. She motivates with a look. "True leadership is not the loudest. It\'s the most felt," she says. Her teammate Selma Bacha summarized it perfectly: "Tiane doesn\'t need an armband. Her leadership is seen in how she trains, how she cares for the group, how she never complains." Application: Next time you want to shout, try being quiet and acting. Well-used silence weighs more than any shout.',
      description_es: 'Tiane nunca fue la más gritona del vestuario. En el Mundial 2019, contra Suecia, cuando el equipo estaba nervioso, ella no dio un discurso. Solo se paró en el centro del círculo, miró a cada una y dijo bajito: "Estamos aquí. Yo las cubro". Y todas respiraron. En Lyon, las jóvenes la buscan para consejos. Ella escucha más que habla. Corrige con una mano en el hombro. Motiva con una mirada. "El verdadero liderazgo no es el que más se oye. Es el que más se siente", dice. Su compañera Selma Bacha lo resumió perfecto: "Tiane no necesita un brazalete. Su liderazgo se ve en cómo entrena, en cómo cuida al grupo, en cómo nunca se queja". En las concentraciones, mientras otras capitanas motivaban con discursos inflamados, ella organizaba las cosas con calma: el orden de las habitaciones, los horarios de comida, las sesiones de video. Pero sobre todo, estaba presente. Ese cemento del silencio es el que une todo sin que nadie se dé cuenta. Aplicación para ti: La próxima vez que quieras gritar, prueba callar y actuar. El silencio bien usado pesa más que cualquier grito.',
      icon: 'Volume2'
    },
    {
      number: 4,
      title_en: 'Resilience Reinforcement',
      title_es: 'Refuerzo de resiliencia',
      subtitle_en: 'Every blow is construction material',
      subtitle_es: 'Cada golpe es material de construcción',
      description_en: 'The 2015 Copa America injury almost killed her. Torn medial meniscus. Season over. Operation. In that moment, in the stadium locker room, with her knee swollen and her Copa America dream shattered, Christiane Endler felt for the first time that the wall was truly cracking. "I seriously thought about retiring," she would confess years later. "I injured my knee and mentally I wasn\'t well." But six months later she was back at Colo-Colo, stronger. Every time she threw herself to the ground, she felt her knee reminding her: "I was here. Here I got up." Cracks are not weakness. They\'re the places where new cement enters. Application: Next time you fall, don\'t ask "why me?". Ask "what new brick am I going to lay with this?"',
      description_es: 'La lesión en la Copa América 2015 casi la mata. Rotura de menisco medial. Temporada terminada. Operación. En ese momento, en el camarín del estadio, con la rodilla hinchada y el sueño de la Copa América roto, Christiane Endler sintió por primera vez que el muro se agrietaba de verdad. "Pensé seriamente en retirarme", confesaría años después. "Me lesioné la rodilla y anímicamente no estaba muy bien". Volvió a Santiago con muletas y el alma hecha pedazos. Pasaba los días en la casa familiar, mirando el techo, preguntándose si todo había valido la pena. Pero su papá le dijo: "Tiane, el muro no se cae por una grieta. Se cae si dejas de poner cemento". Seis meses después estaba de vuelta en Colo-Colo, más fuerte. Cada vez que se tiraba al piso, sentía la rodilla recordándole: "Aquí estuve. Aquí me levanté". Las grietas no son debilidad. Son los lugares por donde entra el cemento nuevo. Aplicación para ti: La próxima vez que te caigas, no preguntes "¿por qué a mí?". Pregunta "¿qué ladrillo nuevo voy a poner con esto?".',
      icon: 'Shield'
    },
    {
      number: 5,
      title_en: 'Strategic Height',
      title_es: 'Altura estratégica',
      subtitle_en: 'Use what others see as disadvantage',
      subtitle_es: 'Usa lo que otros ven como desventaja',
      description_en: 'At 15, her height was a joke. "The tall skinny girl." Today it\'s her superpower. But she always says: "Height gives you advantage, but it doesn\'t save you. True height is mental." In the 2022 Champions final, when Barcelona attacked over and over, her 1.83m allowed her to close spaces others couldn\'t. But it was her reading of the game that saved the match. Physical height you have or you don\'t. Mental height... that\'s built with discipline bricks nobody sees. Application: Take what differentiates you (your "height", your origin, your age, your story) and turn it into your greatest weapon.',
      description_es: 'A los 15 años su altura era una broma. "La flaca alta". Hoy es su superpoder. Pero ella siempre dice: "La altura te da ventaja, pero no te salva. La verdadera altura es la mental". En la final de la Champions 2022, cuando Barcelona atacaba una y otra vez, su 1,83 le permitió achicar espacios que otras no podían. Pero fue su lectura del juego lo que salvó el partido. En Colo-Colo, cuando profesionalizó el equipo, no lo hizo para ella sola. Lo hizo para que las más jóvenes tuvieran lo que ella no tuvo. La altura física la tenía desde los quince. Pero la altura mental... esa se construyó ladrillo a ladrillo, en los entrenamientos solitarios, en las conversaciones con las más chicas, en las noches estudiando videos mientras sus compañeras dormían. Aplicación para ti: Toma lo que te diferencia (tu "altura", tu origen, tu edad, tu historia) y conviértelo en tu mayor arma.',
      icon: 'TrendingUp'
    },
    {
      number: 6,
      title_en: 'Collective Wall',
      title_es: 'Muro colectivo',
      subtitle_en: 'Your defense is stronger when you protect those beside you',
      subtitle_es: 'Tu defensa es más fuerte cuando proteges a las de al lado',
      description_en: 'Tiane never says "I won". She says "we won". At Colo-Colo, when she professionalized the team, she didn\'t do it just for herself. She did it so the younger ones would have what she didn\'t have. In Lyon, she\'s the one who helps the young goalkeepers the most. In La Roja, she\'s the captain who hugs the debutants before they go in. "Your success is collective," she always says. "If I\'m well but the team isn\'t, the wall falls anyway." After the 2022 Champions, she didn\'t celebrate alone. She went to the youngest and told them quietly: "This isn\'t just ours. It\'s for all those who come after." Application: Help someone else climb up. Your wall will be twice as high.',
      description_es: 'Tiane nunca dice "yo gané". Dice "ganamos". En Colo-Colo, cuando profesionalizó el equipo, no lo hizo para ella sola. Lo hizo para que las más jóvenes tuvieran lo que ella no tuvo. Reunió a las chicas y les dijo: "Vamos a juntar plata entre todas y traemos una nutricionista". Grababa los partidos con su propia cámara y al día siguiente analizaba con quien quisiera ver. En Lyon, es la que más ayuda a las arqueras jóvenes. En la Roja, es la capitana que abraza a las debutantes antes de entrar. "Tu éxito es colectivo", dice siempre. "Si yo estoy bien, pero el equipo no, el muro se cae igual". Después de la Champions 2022, no celebró sola. Fue a las más jóvenes y les dijo bajito: "Esto no es solo nuestro. Es de todas las que vienen detrás". Aplicación para ti: Ayuda a alguien más a subir. Tu muro será el doble de alto.',
      icon: 'Users'
    },
    {
      number: 7,
      title_en: 'Emotional Waterproofing',
      title_es: 'Impermeabilización emocional',
      subtitle_en: 'Criticism slides off. Focus remains',
      subtitle_es: 'Las críticas resbalan. El foco se mantiene',
      description_en: 'After the Copa America injury, the comments on social media were harsh: "She got injured again". "She\'s not the same anymore." Tiane read them once and never again. "Criticism slides off when you\'re clear about why you\'re here," she says. In the Champions final, when Barcelona dominated, the stadium booed her. She didn\'t even flinch. Criticism is like rain. If you have a good roof, you only get wet on the outside. Application: Create your waterproofing: a "why" so strong that nothing from outside gets you wet.',
      description_es: 'Después de la lesión en la Copa América, los comentarios en redes fueron duros: "Se lesionó otra vez". "Ya no es la misma". Tiane los leyó una vez y nunca más. "Las críticas resbalan cuando tienes claro para qué estás aquí", dice. En la final de la Champions, cuando el Barcelona dominaba, el estadio la silbaba. Ella ni se inmutó. En ese momento, con 30.000 personas gritando contra ella, Tiane no oyó nada. Solo sintió el balón, el arco, el muro. Las críticas son como la lluvia. Si tienes buen techo, solo te mojas por fuera. Su impermeabilizante es ese "porqué" tan fuerte que nada de afuera la moja: construir para las que vienen detrás, demostrar que el fútbol femenino chileno merece respeto, ser el muro cuando todo se derrumba. Aplicación para ti: Crea tu impermeabilizante: un "porqué" tan fuerte que nada de afuera te moje.',
      icon: 'Umbrella'
    },
    {
      number: 8,
      title_en: 'Constant Reconstruction',
      title_es: 'Reconstrucción constante',
      subtitle_en: 'A wall that isn\'t checked, falls',
      subtitle_es: 'El muro que no se revisa, se cae',
      description_en: 'Every preseason, Tiane reviews her game. Videos of her mistakes. Sessions with the goalkeeper coach. Changes in diet, in strength, in mentality. At 34 she still says: "Always you can improve more." A wall that isn\'t checked falls. Not from an attack. From neglect. Application: Once a month, ask yourself: what part of my wall needs repair?',
      description_es: 'Cada pretemporada, Tiane revisa su juego. Videos de sus errores. Sesiones con el preparador de arqueras. Cambios en la dieta, en la fuerza, en la mentalidad. A los 34 años sigue diciendo: "Siempre se puede mejorar más". En Lyon, después de ganar la Champions 2022, no se conformó. Pidió más videos, más análisis, más trabajo. Porque sabía que el muro no se mantiene solo. Se mantiene con revisión constante, con humildad para ver las grietas, con valentía para repararlas. Un muro que no se revisa se cae. No por un ataque. Por descuido. Por creer que ya está terminado. Aplicación para ti: Una vez al mes, pregúntate: ¿qué parte de mi muro necesita reparación?',
      icon: 'RefreshCw'
    },
    {
      number: 9,
      title_en: 'Armored Door for Dreams',
      title_es: 'Puerta blindada para los sueños',
      subtitle_en: 'Let in only what makes you stronger',
      subtitle_es: 'Deja entrar solo lo que te hace más fuerte',
      description_en: 'Tiane says "no" to many things: parties, distractions, opportunities that don\'t add up. "The goal has a door. I decide who enters," she says. Her family, her faith, her daily work... that does enter. The rest stays outside. The armored door isn\'t to isolate you. It\'s to protect what you\'re building. Application: Make a list of what does enter your wall. And close the door to what doesn\'t.',
      description_es: 'Tiane dice "no" a muchas cosas: fiestas, distracciones, oportunidades que no suman. "El arco tiene una puerta. Yo decido quién entra", dice. Su familia, su fe, su trabajo diario... eso sí entra. Lo demás, queda afuera. Cuando le ofrecieron contratos en clubes más pequeños con mejor sueldo, dijo no. Cuando le pidieron hacer publicidades que no iban con sus valores, dijo no. Cuando le sugirieron bajar el ritmo de entrenamiento porque "ya había ganado todo", dijo no. La puerta blindada no es para aislarte. Es para proteger lo que estás construyendo. Porque si dejas entrar todo, el muro se llena de ruido, de dudas, de distracciones. Y un muro distraído es un muro débil. Aplicación para ti: Haz una lista de lo que sí entra en tu muro. Y cierra la puerta a lo que no.',
      icon: 'Lock'
    },
    {
      number: 10,
      title_en: 'View from Above',
      title_es: 'Vista desde arriba',
      subtitle_en: 'When the wall is finished, all you see is horizon',
      subtitle_es: 'Cuando el muro está terminado, lo único que ves es horizonte',
      description_en: 'Today, with everything won, Tiane looks forward. "The wall isn\'t to enclose you. It\'s to give you the height to see further," she says. She wants to keep playing until 38. She wants La Roja to win something big. She wants Chilean girls to have what she didn\'t have. And when you look at her, you understand: the most beautiful wall isn\'t the tallest. It\'s the one that lets you see the future. Application: These ten bricks aren\'t Tiane\'s. They\'re yours. Take one today. Just one. Lay it. Tomorrow another. And in a year you\'ll look back and say: "I have my wall too."',
      description_es: 'Hoy, con todo ganado, Tiane mira hacia adelante. "El muro no es para encerrarte. Es para darte la altura para ver más lejos", dice. Quiere seguir jugando hasta los 38. Quiere que la Roja gane algo grande. Quiere que las niñas chilenas tengan lo que ella no tuvo. Y cuando la miras, entiendes: el muro más hermoso no es el que más alto llega. Es el que te permite ver el futuro. Desde arriba del muro que construyó ladrillo a ladrillo, Tiane ve horizontes que antes eran imposibles. Ve niñas en Chile que ahora tienen nutricionista, gimnasio, contratos profesionales. Ve una selección femenina que clasificó al Mundial y a los Juegos Olímpicos. Ve un fútbol femenino que ya no es invisible. Y ese horizonte no es solo suyo. Es de todas las que vienen detrás. Aplicación para ti: Estos diez ladrillos no son de Tiane. Son tuyos. Toma uno hoy. Solo uno. Pónlo. Mañana otro. Y dentro de un año vas a mirar atrás y vas a decir: "Yo también tengo mi muro".',
      icon: 'Eye'
    }
  ],
  cta_primary_en: 'Pre-order the Book',
  cta_primary_es: 'Pre-ordenar el Libro',
  cta_secondary_en: 'Read Sample Chapter',
  cta_secondary_es: 'Leer Capítulo de Muestra'
};

export const footerContent = {
  description_en: 'The complete wellness platform for women. Build your wall, brick by brick.',
  description_es: 'La plataforma de bienestar integral para mujeres. Construye tu muro, ladrillo por ladrillo.',
  sections: [
    {
      title_en: 'Platform',
      title_es: 'Plataforma',
      links: [
        { label_en: 'For You', label_es: 'Para Ti', path: '/for-you' },
        { label_en: 'For Professionals', label_es: 'Para Profesionales', path: '/professionals' },
        { label_en: 'For Teams', label_es: 'Para Equipos', path: '/teams' },
        { label_en: 'Download App', label_es: 'Descargar App', path: '/download' }
      ]
    },
    {
      title_en: 'Company',
      title_es: 'Empresa',
      links: [
        { label_en: 'About Us', label_es: 'Sobre Nosotros', path: '/about' },
        { label_en: 'Blog', label_es: 'Blog', path: '/blog' },
        { label_en: 'Careers', label_es: 'Carreras', path: '/careers' },
        { label_en: 'Press', label_es: 'Prensa', path: '/press' }
      ]
    },
    {
      title_en: 'Resources',
      title_es: 'Recursos',
      links: [
        { label_en: 'Academy', label_es: 'Academia', path: '/academy' },
        { label_en: 'Help Center', label_es: 'Centro de Ayuda', path: '/help' },
        { label_en: 'Privacy Policy', label_es: 'Política de Privacidad', path: '/privacy' },
        { label_en: 'Terms of Service', label_es: 'Términos de Servicio', path: '/terms' }
      ]
    }
  ],
  social: [
    { platform: 'Instagram', url: 'https://instagram.com/thewallness', icon: 'Instagram' },
    { platform: 'Twitter', url: 'https://twitter.com/thewallness', icon: 'Twitter' },
    { platform: 'Facebook', url: 'https://facebook.com/thewallness', icon: 'Facebook' },
    { platform: 'Youtube', url: 'https://youtube.com/thewallness', icon: 'Youtube' }
  ],
  copyright_en: '© 2025 The Wallness. All rights reserved.',
  copyright_es: '© 2025 The Wallness. Todos los derechos reservados.'
};